import remarkGfm from 'remark-gfm';

/** Agents write GitHub-flavored markdown: without GFM their tables render as one paragraph of pipes. */
export const REMARK_PLUGINS = [remarkGfm];

/** Tables in agent markdown: bordered cells and a shaded header, scrolling sideways inside the message rather than widening it. */
export const MARKDOWN_TABLE_SX = {
  '& table': { display: 'block', overflowX: 'auto', borderCollapse: 'collapse', my: 1 },
  // Words stay whole, so a table too wide for the message scrolls instead of breaking them apart
  '& th, & td': { border: 1, borderColor: 'divider', px: 1, py: 0.5, textAlign: 'left', overflowWrap: 'normal' },
  '& th': { bgcolor: 'action.hover', fontWeight: 600 },
} as const;
